import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import toolbarClasses from './Toolbar.module.scss';

export default function Toolbar({ logo, children, className }) {
  const classes = cx(toolbarClasses.toolbar, className);
  return (
    <header className={classes}>
      {logo}
      {children}
    </header>
  );
}

Toolbar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.object,
  className: PropTypes.string,
};
